import { render } from "./FireBaseTop.vue?vue&type=template&id=097e875a"
import script from "./FireBaseTop.vue?vue&type=script&lang=js"
export * from "./FireBaseTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__